module.exports = __webpack_public_path__ + "static/media/dungeon_floor_e2.08aaa4e1.png";